export const ORDER_LIST = "ORDER_LIST"
export const ORDER_DETAIL = "ORDER_DETAIL"
export const ORDER_UPDATE_STATUS = "ORDER_UPDATE_STATUS"
export const ITEM_DETAIL = "ITEM_DETAIL"
export const ADD_ITEM = "ADD_ITEM"
export const UPDATE_ITEM = "UPDATE_ITEM"
export const CANCEL_ITEM = "CANCEL_ITEM"
export const GET_ITEM = "GET_ITEM"
export const CHECK_UPDATE = "CHECK_UPDATE"